<template>
  <div ref="chartRef" class="ring-pure-safe"></div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'RingPureColorSafe',
  props: {
    data: {
      type: Array,
      required: true
    },
    colors: {
      type: Array,
      default: () => ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de']
    },
    innerRadius: {
      type: Number,
      default: 50
    },
    outerRadius: {
      type: Number,
      default: 55
    }
  },
  data() {
    return {
      chartInst: null,
      ro: null
    }
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.chartInst ? this.render() : this.tryInit()
      }
    }
  },
  mounted() {
    this.tryInit()
  },
  beforeDestroy() {
    this.clean()
  },
  methods: {
    /* 关键：防 0 高度 */
    tryInit() {
      const dom = this.$refs.chartRef
      if (!dom) return
      if (dom.clientHeight > 0) {
        this.render()
        return
      }
      this.ro = new ResizeObserver(entries => {
        const h = entries[0].contentRect.height
        if (h > 0) {
          this.ro.disconnect()
          this.ro = null
          this.render()
        }
      })
      this.ro.observe(dom)
    },

    render() {
      this.$nextTick(() => {
        const dom = this.$refs.chartRef
        if (!dom || dom.clientHeight === 0) return
        if (!this.chartInst) {
          this.chartInst = echarts.init(dom)
          window.addEventListener('resize', this.handleResize)
        }
        this.chartInst.setOption(this.buildOption(), true)
        this.chartInst.resize()
      })
    },

    buildOption() {
      const colorFn = (_, idx) => this.colors[idx % this.colors.length]
      return {
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)',
          position: function (point, params, dom, rect, size) {
            const x = point[0] - size.contentSize[0] / 2  // 水平居中
            const y = point[1] - size.contentSize[1] - 10  // 上方 10px 间距
            return [x, y]
          },
          backgroundColor: 'rgba(255,255,255,0.95)',
          borderColor: '#E4E7ED',
          borderWidth: 1,
          padding: [8, 12],
          textStyle: {
            color: '#252B3C',
            fontSize: 13
          },
          extraCssText: 'box-shadow: 0 2px 8px rgba(0,0,0,0.08); border-radius: 4px;'
        },
        color: this.colors,
        series: [
          {
            type: 'pie',
            radius: [this.innerRadius, this.outerRadius],
            selectedMode: 'single',
            selectedOffset: 16,
            clockwise: true,
            startAngle: 90,
            label: { show: false },
            labelLine: { show: false },
            data: this.data.map((item, idx) => ({
              name: item.name,
              value: item.value,
              itemStyle: { color: colorFn(item, idx) }
            }))
          }
        ]
      }
    },

    handleResize() {
      this.chartInst && this.chartInst.resize()
    },

    clean() {
      if (this.ro) { this.ro.disconnect(); this.ro = null }
      if (this.chartInst) { this.chartInst.dispose(); this.chartInst = null }
      window.removeEventListener('resize', this.handleResize)
    }
  }
}
</script>

<style scoped>
.ring-pure-safe {
  width: 100%;
  height: 100%;
  min-height: 200px;
}
</style>
